import { Common } from '@thecvlb/design-system';
import classNames from 'classnames';

export type InterpreterButtonProps = {
  className?: string;
  dataTestId?: string;
  isRequested: boolean;
  onClick: () => void;
  size?: 'sm' | 'md' | 'lg';
};

/** Shared "Request interpreter" / "Interpreter requested" button for lobby and settings. */
const InterpreterButton = ({
  className,
  dataTestId = 'request_interpreter',
  isRequested,
  onClick,
  size = 'sm'
}: InterpreterButtonProps) => (
  <Common.Button
    data-tooltip-id="interpreter-tooltip"
    dataTestId={dataTestId}
    size={size}
    onClick={onClick}
    preIcon="earth"
    className={classNames(className, { '!text-green': isRequested })}
  >
    {isRequested ? (
      <>
        Interpreter requested
        <span className="ml-auto font-normal text-gray">Cancel</span>
      </>
    ) : (
      'Request interpreter'
    )}
  </Common.Button>
);

export default InterpreterButton;
